<template>
    <el-form label-position="left" :model="formData" ref="ruleForm" :rules="rules" @validate="handleValidate" class="notify-form" label-width="120px">
        <FormGroup>通知</FormGroup>
        <el-form-item label="通知方式" prop="notification_way">
            <el-checkbox-group v-model="formData.notification_way" :disabled="isView">
                <el-checkbox-button label="1">邮件</el-checkbox-button>
                <el-checkbox-button label="2">企业微信</el-checkbox-button>
                <el-checkbox-button label="3">站内信</el-checkbox-button>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="通知人" prop="notification_user">
            <ESelect
                v-model="formData.notification_user"
                @change="changeNotification"
                multiple
                filterable
                :disabled="isView"
                style="width: 500px;"
                placeholder="请选择通知人">
                <el-option
                    v-for="item in notifierConfig"
                    :key="item.id"
                    :label="item.display_name"
                    :value="item.id">
                </el-option>
            </ESelect>
        </el-form-item>
        <el-form-item label="指定通知人" prop="notification_designated_person" v-show="isDesignatedPerson" class="label-required">
            <ESelect
                v-model="formData.notification_designated_person"
                multiple
                filterable
                remote
                reserve-keyword
                :remote-method="remoteGetUserList"
                :loading="userLoading"
                :disabled="isView"
                style="width: 500px;"
                placeholder="请指定通知人">
                <el-option
                    v-for="item in userList"
                    :key="item.id+item.name"
                    :label="item.name+'（'+item.group_name_with_parent+' / '+item.group_name+'）'"
                    :value="item.id">
                </el-option>
            </ESelect>
            <el-button type="primary" class="ml10" v-if="!isView" @click="showBatchModal('notifier')" plain>批量导入</el-button>
        </el-form-item>
        <el-form-item label="指定邮箱" prop="notification_designated_email" v-show="isDesignatedEmail" class="label-required">
            <el-input type="textarea" v-model="formData.notification_designated_email" :disabled="isView" :rows="1" :autosize="{minRows: 1,maxRows: 6}" placeholder="请输入邮箱，多个使用英文逗号“,”分割" style="width: 500px;"></el-input>
            <el-button type="primary" class="ml10" v-if="!isView" @click="showBatchModal('email')" plain>批量导入</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import FormGroup from '../formGroup';
    import {batchChooseModal} from '../../modal/index';
    import API from '@/api/intelligent/intelligentManaged/index.js';
    import {uniq } from 'lodash';

    export default {
        name: "NotifyInfo",
        components:{
            FormGroup,
        },
        props:['notifierConfig'],
        inject:['validFormItem','isView'],
        data(){
            let _this = this;
            const validateEmail = (rule,value,callback)=>{
                if(!_this.isDesignatedEmail){
                    callback();
                }else if(!value){
                    callback(new Error('请输入收件人邮箱'));
                }else{
                    let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                    let mailArr = value.replace(/[;,，]/g,",").split(',');
                    if(mailArr.every(item=>reg.test(item))){
                        callback();
                    }else if(mailArr.filter(item=>!!item).length>50){
                        callback(new Error('最多支持50个邮箱'));
                    }else{
                        callback(new Error('请输入正确邮箱'));
                    }
                }
            };
            const validatePerson = (rule,value,callback)=>{
                if(!_this.isDesignatedPerson){
                    callback();
                }else if(!value||value.length<=0){
                    callback(new Error('请选择指定通知人'));
                }else if(value.length>50){
                    callback(new Error('最多选择50个人'));
                }else{
                    callback();
                }
            };
            return {
                formData:{
                    notification_way:['1','2','3'],
                    notification_user:[],
                    notification_designated_person:[],
                    notification_designated_email:'',
                },
                rules:{
                    notification_way:[
                        { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' },
                    ],
                    notification_user:[
                        { type: 'array', required: true, message: '请选择通知人', trigger: 'change' },
                    ],
                    notification_designated_person:[
                        // { type: 'array', required: true, message: '请选择指定通知人', trigger: 'change' },
                        { validator:validatePerson ,trigger:'change'},
                    ],
                    notification_designated_email:[
                        { validator:validateEmail ,trigger:'blur'},
                    ],
                },
                userList:[],
                userLoading:false,
                batchChooseModal:null,
            }
        },
        computed:{
            isDesignatedEmail(){
                let emailItem = this.notifierConfig.find(item=>item.name=='designated_email')||{};
                return this.formData.notification_user.includes(emailItem.id);
            },
            isDesignatedPerson(){
                let personItem = this.notifierConfig.find(item=>item.name=='designated_notifier')||{};
                return this.formData.notification_user.includes(personItem.id);
            },
        },
        watch: {
            notifierConfig: {
                handler(new_value) {
                    if(Array.isArray(new_value)&&new_value.length>0&&!this.isView){
                        this.setDefaultNotificationWay();
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods:{
            setFormData(data){
                console.log('setFormData',data);

                this.formData.notification_way = (data.notification_way||"").split(',');
                this.formData.notification_user = (data.notification_user||"").split(',');
                this.formData.notification_designated_email = (data.notification_designated_email||"");
                this.formData.notification_designated_person = (data.notification_designated_person||[]).map(item=>item.uid);
                this.userList = (data.notification_designated_person||[]).map(item=>{
                    item.id = item.uid;
                    return item;
                })
            },
            setDefaultNotificationWay(){
                let creatorItem = this.notifierConfig.find(item=>item.name=='creator');
                if(creatorItem){
                    this.formData.notification_user.push(creatorItem.id);
                }
                let leaderItem =this.notifierConfig.find(item=>item.name=='creator_leadership');
                if(leaderItem){
                    this.formData.notification_user.push(leaderItem.id);
                }
            },
            handleValidate(key, valid, info){
                const data = {
                    notification_way: '通知方式',
                    notification_user: '通知人',
                    notification_designated_person: '指定通知人',
                    notification_designated_email: '指定邮箱',
                };
                if (!valid) {
                    this.validFormItem(`通知-${data[key]}：${info}`);
                }
            },
            changeNotification(val){
                console.log('changeNotification',val);
                if(!this.isDesignatedPerson){
                    this.formData.notification_designated_person = [];
                }
                if(!this.isDesignatedEmail){
                    this.formData.notification_designated_email = '';
                }
            },
            remoteGetUserList(query){
                if (query !== '') {
                    this.userLoading = true;
                    API.getNotifyUserList({
                        search:query,
                    }).then(res=>{
                        console.log('getNotifyUserList',res);
                        let resData = res.data||{};
                        this.userList = resData.list||[];
                        this.userLoading = false;
                    },err=>{
                        console.log('getNotifyUserList err',err);
                        this.userList = [];
                        this.userLoading = false;
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                        this.$message.error(err.info||'请求异常');
                    })
                } else {
                    this.userList = [];
                }
            },
            showBatchModal(type){
                console.log('showBatchModal',type);
                this.batchChooseModal = batchChooseModal({
                    props:{

                    },
                    cbs:{
                        onSubmit:(data,cb)=>{
                            console.log('onSubmit：批量',data,cb);
                            if(uniq(data).length>1000) {
                                this.$message.error('最多可批量导入1000条数据');
                                return cb();
                            }
                            if(type=='notifier'){
                                API.getNotifyUserList({
                                    batch_search:data,
                                }).then(res=>{
                                    console.log('getNotifyUserList',res);
                                    let resData = res.data||[];
                                    let successList = resData.list||{};
                                    let errList = resData.err_list||[];
                                    if(errList.length>0){
                                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                                        htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                                        this.$confirm(htmlStr, '提示', {
                                            confirmButtonText: '剔除',
                                            cancelButtonText: '关闭',
                                            dangerouslyUseHTMLString: true,
                                            type: 'error',
                                            customClass:'batch-err-tips-modal',
                                            width:'500',
                                        }).then(()=>{
                                            successList.forEach(item=>{
                                                this.addUser(item);
                                            });
                                            this.batchChooseModal.vm.close();
                                        }).catch(()=>{
                                            cb();
                                        });
                                    }else{
                                        successList.forEach(item=>{
                                            this.addUser(item);
                                        });
                                        this.batchChooseModal.vm.close();
                                    }
                                },err=>{
                                    console.log('getNotifyUserList err',err);
                                    this.userList = [];
                                    this.userLoading = false;
                                });
                            }else if(type=='email'){
                                console.log(333,'em');

                                let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;

                                let successList = [];
                                let errList = [];

                                data.forEach(item=>{
                                    if(reg.test(item)){
                                        successList.push(item);
                                    }else{
                                        errList.push(item);
                                    }
                                });

                                if(errList.length>0){
                                    let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                                    htmlStr += '<p>未找到以下内容，请核实，是否需要剔除未找到的内容?</p>';
                                    htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                                    this.$confirm(htmlStr, '提示', {
                                        confirmButtonText: '剔除',
                                        cancelButtonText: '关闭',
                                        dangerouslyUseHTMLString: true,
                                        type: 'error',
                                        customClass:'batch-err-tips-modal',
                                        width:'500',
                                    }).then(()=>{
                                        this.addEmail(successList);
                                        this.batchChooseModal.vm.close();
                                    }).catch(()=>{
                                        cb();
                                    });
                                }else{
                                    this.addEmail(successList);
                                    this.batchChooseModal.vm.close();
                                }



                            }
                        },
                    },
                })
            },
            addUser(item){
                console.log('addUser',item);
                if(!this.userList.find(inner=>inner.id==item.id)){
                    this.userList.push(item);
                }
                if(!this.formData.notification_designated_person.includes(item.id)){
                    this.formData.notification_designated_person.unshift(item.id);
                }
            },
            addEmail(list){
                if(!this.formData.notification_designated_email){
                    this.formData.notification_designated_email = list.join(',');
                }else{
                    let oldList = this.formData.notification_designated_email.split(',');
                    this.formData.notification_designated_email = uniq(oldList.concat(list)).filter(item=>!!item).join(',');
                }
            },
            // 获取表单数据
            async validateFn() {
                const valid = await this.$refs.ruleForm.validate();
                if (valid) {
                    return {...this.formData}
                }
            },
        },

    }
</script>

<style lang="scss" scoped>
    .notify-form ::v-deep .el-checkbox-group .el-checkbox-button.is-disabled.is-checked  .el-checkbox-button__inner{
        background-color: #f2f6fc;
        color: #C0C4CC;
    }
</style>
